module.exports = __webpack_public_path__ + "img/txt_series_104.4e3fc049.png";